require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/fn/object/values.js
 ** module id = 215
 ** module chunks = 0
 **/